// extracted by mini-css-extract-plugin
export default {"iconButton":"IconButton_iconButton__yw0-w"};